import SelectableListComponent from "./selectable-list";
import { useEffect, useState, useRef } from "react";
function SelectableList({
  title,
  list,
  value,
  isMultiSelect,
  onItemSelect,
  isEnabled,
  isOpen: initialOpen,
  onHeaderClick,
  className,
  headerClassName,
  titleClassName,
}) {
  var header = isMultiSelect ? createHeaderFromList(value) : value;

  const ref = useRef(null);
  const [isOpen, setOpen] = useState(initialOpen);

  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    setOpen(initialOpen);
  }, [initialOpen]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleHeaderClick = () => {
    if (!isEnabled) {
      return;
    }
    if (onHeaderClick) {
      onHeaderClick();
    }
    setOpen(!isOpen);
  };

  const handleItemSelectClick = ({ name, event }) => {
    onItemSelect({ name });
    if (!isMultiSelect) {
      setOpen(false);
    }
  };

  const handleCloseList = () => {
    setOpen(false);
  };

  return (
    <div ref={ref} className={className}>
      <SelectableListComponent
        list={list}
        selectedItem={header}
        title={title}
        isEnabled={isEnabled}
        isMultiSelect={isMultiSelect}
        onItemSelect={handleItemSelectClick}
        onHeaderClick={handleHeaderClick}
        onCloseList={handleCloseList}
        offsetWidth={ref?.current?.offsetWidth}
        isOpen={isOpen}
        className={className}
        headerClassName={headerClassName}
        titleClassName={titleClassName}
      />
    </div>
  );
}

function createHeaderFromList(list) {
  if (typeof list === "string" || list instanceof String) {
    return list;
  }

  var value = "";
  list?.forEach(({ name, title, isSelected }) => {
    var label = name ? name : title;
    if (isSelected) {
      if (value.length) {
        value = value + ", ";
      }
      value = value + label;
    }
  });
  return value;
}

export default SelectableList;
